import React from 'react';
import { Gift } from 'lucide-react';
import '../styles/Header.css';

const Header = () => {
    return (
        <header className="site-header">
            <div className="logo">
                <Gift size={24} />
                <span>RewardRedeemer</span>
            </div>
            <nav className="nav">
                <ul>
                    <li><a href="#">Home</a></li>
                    <li><a href="#" className="active">Redeem</a></li>
                    <li><a href="#">FAQ</a></li>
                    <li><a href="#">Support</a></li>
                </ul>
            </nav>
        </header>
    );
};

export default Header;